import type { Skill } from '../domain/types.js';

// Group skills by category name (lowercased). Buckets are built purely from
// the data — categories with no skills simply don't appear.
export const transformSkills = (
  skills: Skill[],
): { [key: string]: Skill[] } => {
  const transformed: { [key: string]: Skill[] } = {};

  skills.forEach((skill) => {
    skill.categories.forEach((category) => {
      const categoryName = category.name.toLowerCase();

      if (!transformed[categoryName]) {
        transformed[categoryName] = [];
      }

      transformed[categoryName].push(skill);
    });
  });

  return transformed;
};

// Newest first, total order: undated or unparseable dates sink to the end.
export const sortByDateDesc = <T>(
  items: T[],
  getDate: (item: T) => string | null | undefined,
): T[] => {
  const key = (date?: string | null): number => {
    const time = date ? Date.parse(date) : NaN;
    return Number.isNaN(time) ? -Infinity : time;
  };

  return [...items].sort((a, b) => {
    const keyA = key(getDate(a));
    const keyB = key(getDate(b));
    // Guard the subtraction: -Infinity - -Infinity would be NaN.
    return keyA === keyB ? 0 : keyB - keyA;
  });
};
